import React, { useContext, useEffect, useState } from "react";
import ServiceWrapper from "../../../../Services/ServiceWrapper";
import AuthManager from "../../../../Common/AuthManager";
import AppSettings from "../../../../Settings/AppSettings";
import { CategoryContext } from "../CategoryContext";
import { AppContext } from "../../../../Context/AppContext";
import Utils from "../../../../Common/Utils";
import { toast } from "Components/DesignSystem/Toast/useToast";
import orderBy from "lodash/orderBy";
import ViewMoreButton from "../../../Common/components/ViewMoreButton";
import LoadingSuccessErrorAlert from "./LoadingSuccessErrorAlert";
import Accordion from "Components/DesignSystem/Accordion/Accordion";
import Badge from "Components/DesignSystem/Badge/Badge";
import Button from "Components/DesignSystem/Button/Button";
import ChoiceChip from "Components/DesignSystem/ChoiceChip/ChoiceChip";
import EmptyState from "Components/DesignSystem/EmptyState/EmptyState";
import Search from "Components/DesignSystem/Search/Search";
import Tag from "Components/DesignSystem/Tag/Tag";
import Tooltip from "Components/DesignSystem/Tooltip/Tooltip";
import Typography from "Components/DesignSystem/Typography/Typography";

// number of attributes to show at a time
const _max_items_show = 10

/**
 * Associated Attributes — on the design system since the category module's
 * Phase 4. Every service call, payload shape, permission check, state flow and
 * timer (including the § 5.4 forced-success 2000ms) is the legacy logic
 * verbatim; only the rendering changed: DS Accordion (controlled, with the
 * § 192 actions slot the legacy floated over its header with -34px margins),
 * Tag chips for the selection, ChoiceChip for the picker (tone danger = the
 * § 193 pending-removal marker the legacy drew as a red bootstrap outline),
 * DS Search, and the § 99 status strip.
 */
const AssociatedAttributes = () => {
  let api_base_url = AppSettings.GMS_BACKEND_API_URL;
  let appContext = useContext(AppContext);
  let industryId =
    appContext.get_selected_industry() && appContext.get_selected_industry().id;
  const { editingItem, setReloadComp } = useContext(CategoryContext);
  const [loading, setLoading] = useState({
    status: "",
    message: "",
  });

  const [collapse, setCollapse] = useState(false);
  const [EditPage, setEditPage] = useState(false);
  let [associatedAttributes, setAssociatedAttributes] = useState(null);
  const [attributeList, setAttributeList] = useState(null);
  const [sortedAttributeList, setSortedAttributeList] = useState([]);
  const [checkedAttributes, setCheckedAttributes] = useState([]);
  let [filteredAttList, setFilteredAttList] = useState(sortedAttributeList);
  let [searchString, setSearchString] = useState("");
  const appData = useContext(AppContext);
  const [showClearAllFlag,setshowClearAllFlag] = useState(true)
  const [viewMoreAttributes, setViewMoreAttributes] = useState(false)
  const [viewMoreAssoAttributes, setViewMoreAssoAttributes] = useState(false)

  useEffect(() => {
    setCheckedAttributes(associatedAttributes);
    const sharedFlag = checkSharedCategories(associatedAttributes || []);
    setshowClearAllFlag(sharedFlag);
  }, [associatedAttributes]);

  useEffect(() => {
    setAssociatedAttributes(null);
    setAttributeList(null);
    setLoading({
      status: "",
      message: "",
    });
  }, [editingItem.id]);

  useEffect(() => {
    if (associatedAttributes === null && collapse) {
      load_associated_attributes();
    }
  }, [collapse]);

  useEffect(() => {
    if (EditPage) {
      load_associated_attributes();
      load_Attributes();
    }
  }, [EditPage]);

  useEffect(() => {
    let arr = [];
    if (
      associatedAttributes &&
      associatedAttributes.length > 0 &&
      attributeList
    ) {
      attributeList.map((i) => {
        let obj = associatedAttributes.find((att) => att.id === i.id);
        if (obj !== undefined) {
          arr.unshift(i);
        } else {
          arr.push(i);
        }
      });
    } else if (attributeList) {
      arr = [...attributeList];
    }

    if (checkedAttributes?.length === 0) {
      arr = updateCategories(arr, associatedAttributes || []);
    } else {
      arr = updateCategories(arr, checkedAttributes || []);
    }

    setSortedAttributeList(arr);
    if (!EditPage) {
      setSortedAttributeList([]);
    }
  }, [attributeList, EditPage]);

  async function load_associated_attributes() {
    setLoading({ status: "Loading", message: "Loading Associated attributes" });
    let res = await ServiceWrapper.doGet(
      `${api_base_url}category/${editingItem.id}/associatedattributes/list`,
      null,
      null,
      AuthManager.getGmsToken()
    );
    if (!res.errorfound) {
      setLoading({ status: "Success", message: undefined });
      const mappedExistingAttribute = mapExistingAttributes(res.data.data);
      setAssociatedAttributes(mappedExistingAttribute);
    } else {
      setLoading({ status: "Error", message: "Error while loading details" });
    }
  }

  function handle_collapse() {
    setCollapse(!collapse);
    // setEditPage(false)
  }

  async function handle_save() {
    setLoading({
      status: "Loading",
      message: "updating associated attributes",
    });
    let newlyAdded = [...checkedAttributes];
    let newlyDeleted = [];
    associatedAttributes.map((item) => {
      let index = newlyAdded.findIndex((att) => att.id === item.id);
      if (index === -1) {
        let { id } = item;
        newlyDeleted.push({ id });
      } else {
        newlyAdded.splice(index, 1);
      }
    });

    let res = await ServiceWrapper.doPost(
      `${api_base_url}category/${editingItem.id}/associatedattributes/edit`,
      {
        add_attributes: newlyAdded,
        delete_attributes: newlyDeleted,
        industry_id: industryId,
      },
      null,
      AuthManager.getGmsToken()
    );

    if (!res.errorfound) {
      if (res.data.done) {
        setLoading({
          status: "Success",
          message: res.data.message,
        });
        setEditPage(false);
        load_associated_attributes();
        setReloadComp((n) => n + 1);
      } else {
        setEditPage(false);
        setLoading({
          status: "Error",
          message: res.data.message,
        });
      }
    } else {
      setEditPage(false);
      setLoading({
        status: "Error",
        message: "Error while saving, Please try after some time.",
      });
    }
    setTimeout(() => {
      setLoading({ status: "Success", message: undefined });
      setEditPage(false);
    }, 2000);
    // Clear Search item
    setSearchString("");
  }

  async function load_Attributes(showStatus = true) {
    if (showStatus) {
      setLoading({
        status: "Loading",
        message: "Loading Attributes",
      });
    }
    let api_base_url = AppSettings.GMS_BACKEND_API_URL;
    let ret = await ServiceWrapper.doGet(
      `${api_base_url}industry/${industryId}/attribute/list`,
      null,
      null,
      AuthManager.getGmsToken()
    );
    if (!ret.errorfound) {
      await setAttributeList(ret.data.data);

      setLoading({
        status: "Success",
        message: undefined,
      });
    } else {
      setLoading({
        status: "Error",
        message: "Error while Loading Attributes",
      });
    }
  }

  function getChecked(id) {
    let obj = checkedAttributes.find((att) => att.id === id);
    return obj !== undefined;
  }

  useEffect(() => {
    if (EditPage && searchString === "") {
      if (checkedAttributes && checkedAttributes.length > -1) {
        let updatedAtt = updateCategories(
          sortedAttributeList,
          checkedAttributes
        );
        updatedAtt = mapFilteredData(updatedAtt, associatedAttributes);
        updatedAtt = sortCatArray(updatedAtt);
        setFilteredAttList(updatedAtt);
      }
    }
  }, [searchString, sortedAttributeList]);

  async function handleSearchAttribute(value) {
    setSearchString(value);
    if (!Utils.isEmpty(value)) {
      let searchval = value.toString().trim().toLowerCase();
      let filteredData = sortedAttributeList.filter((item) => {
        return (
          (item.name != null && item.name.toLowerCase().includes(searchval)) ||
          (item.description != null &&
            item.description.toLowerCase().includes(searchval))
        );
      });
      filteredData = updateCategories(filteredData, checkedAttributes);
      filteredData = mapFilteredData(filteredData, associatedAttributes);
      // setFilteredAttList(updatedAtt);
      filteredData = sortCatArray(filteredData);
      setFilteredAttList(filteredData);
    }
  }

  function handle_cancel() {
    setEditPage(false);
    setSearchString("");
    setCheckedAttributes([]);
    setSortedAttributeList([]);
  }

  const fromSelectedToAllAttribute = (categoryItem) => {
    const filteredCheckedItems = checkedAttributes?.filter((item) => {
      return item.id !== categoryItem.id;
    });
    setCheckedAttributes(filteredCheckedItems);
    const catArrData = sortCatArray([...filteredAttList, categoryItem]);
    setFilteredAttList(catArrData);
    if (searchString !== "") {
      setSearchString("");
    }
    const sharedFlag = checkSharedCategories(filteredCheckedItems);
    setshowClearAllFlag(sharedFlag);
  };

  const clearAllCheckedItems = () => {
    const sharedCheckedAttribute = checkedAttributes.filter(
      (item) => item.shared
    );
    const uncheckedCategories = checkedAttributes.filter(
      (item) => !item.shared
    );
    const catArrData = sortCatArray([
      ...filteredAttList,
      ...uncheckedCategories,
    ]);
    setFilteredAttList(catArrData);
    setCheckedAttributes(sharedCheckedAttribute);
    // setSearchString
    setSearchString("");
    setshowClearAllFlag(false);
  };

  function updateCategories(filteredCatAttList, checkedCatArray) {
    for (const catObject of checkedCatArray) {
      filteredCatAttList = filteredCatAttList.filter((item) => {
        return item.id !== catObject.id;
      });
    }
    return filteredCatAttList;
  }

  function mapExistingAttributes(existingAttributeArray) {
    existingAttributeArray = existingAttributeArray?.map((item) => {
      item.removed_from_selected_items = true;
      return item;
    });
    return existingAttributeArray;
  }

  function mapFilteredData(filteredArrData, checkedArrayData) {
    if (checkedArrayData && checkedArrayData.length > 0) {
      for (const item of checkedArrayData) {
        filteredArrData = filteredArrData?.map((attributeData) => {
          if (item.id === attributeData.id) {
            attributeData.removed_from_selected_items = true;
          }
          return attributeData;
        });
      }
    }
    return filteredArrData;
  }

  function sortCatArray(catArr) {
    catArr = orderBy(catArr, ["name"], ["asc"]);
    return catArr;
  }

  function checkSharedCategories(allCategoriesArr) {
    let sharedFlag = false;
    allCategoriesArr.map((item) => {
      if (!item.shared) {
        sharedFlag = true;
      }
    });
    return sharedFlag;
  }

  /* Header-row actions (§ 192): the legacy floated these OVER the header with
     zIndex + marginTop:-34px; same render condition, same handlers. */
  const headerActions =
    collapse && loading.status === "Success" ? (
      !EditPage ? (
        <Button
          variant="subtle"
          size="sm"
          data-testid="category-associated-attributes-edit-btn"
          onClick={() => {
            if (appData.pm.checkPermission("gmscategory_update")) {
              setEditPage(true);
            } else {
              toast.info(
                "You don't have permission to edit associated attribute"
              );
            }
          }}
        >
          Edit
        </Button>
      ) : (
        <>
          <Button
            variant="subtle"
            size="sm"
            data-testid="category-associated-attributes-reset-btn"
            disabled={
              JSON.stringify(associatedAttributes) ===
              JSON.stringify(checkedAttributes)
            }
            onClick={() => {
              const actualAttributeData = updateCategories(
                sortedAttributeList,
                associatedAttributes
              );
              setFilteredAttList(actualAttributeData);
              setCheckedAttributes(associatedAttributes);
              setSearchString("");
              const sharedFlag =
                checkSharedCategories(associatedAttributes);
              setshowClearAllFlag(sharedFlag);
            }}
          >
            Reset
          </Button>
          <Button
            variant="secondary"
            size="sm"
            data-testid="category-associated-attributes-cancel-btn"
            onClick={handle_cancel}
          >
            Cancel
          </Button>
          <Button
            variant="primary"
            size="sm"
            data-testid="category-associated-attributes-save-btn"
            disabled={
              JSON.stringify(associatedAttributes) ===
              JSON.stringify(checkedAttributes)
            }
            onClick={() => handle_save()}
          >
            Save
          </Button>
        </>
      )
    ) : undefined;

  return (
    <Accordion
      title={`${EditPage ? "Edit " : ""}Associated Attributes`}
      open={collapse}
      onOpenChange={() => handle_collapse()}
      actions={headerActions}
      data-testid="components-associatedattributes-div-1"
      variant="boxed"
    >
      <div className="tw-pb-4">
        <LoadingSuccessErrorAlert
          loading={loading}
          data-testid="category-associated-attributes-status"
        />
        {EditPage ? (
          <div className="tw-mt-3 tw-border tw-border-edge tw-rounded-ctl">
            <div className="tw-flex tw-items-center tw-gap-2 tw-px-4 tw-py-2 tw-bg-surface-sunken">
              <Typography variant="title-header" as="h3" className="tw-mb-0 tw-text-ink">
                Selected Attributes
              </Typography>
              <Badge variant="secondary">{checkedAttributes?.length}</Badge>
            </div>
            <div className="tw-p-4">
              <div className="tw-flex tw-flex-wrap tw-items-center tw-gap-2">
                {checkedAttributes && checkedAttributes.length > 0 ? (
                  <>
                    {checkedAttributes
                      .slice(
                        0,
                        viewMoreAssoAttributes
                          ? checkedAttributes.length
                          : Math.min(_max_items_show, checkedAttributes.length)
                      )
                      .map((item, index) =>
                        !item.shared ? (
                          <Tag
                            key={index}
                            label={item.name}
                            data-testid={`category-associated-attribute-${item.id}`}
                            removeLabel="Remove attribute"
                            onRemove={() => {
                              fromSelectedToAllAttribute(item);
                            }}
                          />
                        ) : (
                          <Tooltip
                            key={index}
                            content="Attribute associated with categories, products, rules or builder cannot be removed."
                            placement="bottom"
                          >
                            <Tag
                              label={item.name}
                              variant="meta"
                              data-testid={`category-associated-attribute-${item.id}`}
                            />
                          </Tooltip>
                        )
                      )}
                  </>
                ) : (
                  <Typography variant="body-primary" className="tw-text-ink-secondary">
                    No Attributes found
                  </Typography>
                )}
                <ViewMoreButton
                  state={viewMoreAssoAttributes}
                  handleClick={() => setViewMoreAssoAttributes(!viewMoreAssoAttributes)}
                  condition={checkedAttributes?.length > _max_items_show}
                />
              </div>
              {checkedAttributes?.length > 0 && showClearAllFlag ? (
                <Button
                  variant="subtle"
                  size="sm"
                  className="tw-mt-2"
                  data-testid="components-associatedattributes-div-3"
                  onClick={clearAllCheckedItems}
                >
                  Clear All
                </Button>
              ) : null}
            </div>
          </div>
        ) : null}

        {loading.status === "Success" && (
          <>
            {EditPage ? (
              <>
                {loading.status !== "Loading" && (
                  <div className="tw-mt-3 tw-border tw-border-edge tw-rounded-ctl tw-overflow-hidden">
                    <div className="tw-flex tw-justify-between tw-items-center tw-gap-3 tw-px-4 tw-py-2 tw-bg-surface-sunken">
                      <Typography variant="title-header" as="h3" className="tw-mb-0 tw-text-ink">
                        Attributes
                      </Typography>
                      <Search
                        size="sm"
                        className="tw-w-64"
                        placeholder="Search Attribute"
                        ariaLabel="Search attributes"
                        data-testid="components-associatedattributes-input-1"
                        value={searchString}
                        onChange={(value) => handleSearchAttribute(value)}
                      />
                    </div>

                    <div className="tw-flex tw-flex-wrap tw-items-center tw-gap-2 tw-p-4">
                      {filteredAttList && filteredAttList.length > 0 ? (
                        <>
                          {filteredAttList
                            .slice(
                              0,
                              viewMoreAttributes || searchString !== ""
                                ? filteredAttList.length
                                : Math.min(_max_items_show, filteredAttList.length)
                            )
                            .map((item, index) => (
                              <ChoiceChip
                                key={index}
                                label={item.name}
                                selected={
                                  !!(
                                    checkedAttributes &&
                                    checkedAttributes.length > 0 &&
                                    getChecked(item.id)
                                  )
                                }
                                /* § 193: was associated before this edit — adding it
                                   back restores a saved association. Legacy drew this
                                   as btn-outline-danger. */
                                tone={
                                  item?.removed_from_selected_items
                                    ? "danger"
                                    : "default"
                                }
                                data-testid={`components-associatedattributes-input-2-${item.id}`}
                                onClick={() => {
                                  setshowClearAllFlag(true);
                                  const filteredAttListArr =
                                    filteredAttList?.filter((att) => {
                                      return att.id !== item.id;
                                    });
                                  let checkedArr = [
                                    ...checkedAttributes,
                                    item,
                                  ];

                                  setCheckedAttributes(checkedArr);
                                  setFilteredAttList(filteredAttListArr);
                                  // }
                                }}
                              />
                            ))}
                          <ViewMoreButton
                            state={viewMoreAttributes}
                            handleClick={() => setViewMoreAttributes(!viewMoreAttributes)}
                            condition={searchString === "" && filteredAttList?.length > _max_items_show}
                          />
                        </>
                      ) : (
                        <>
                          {searchString !== "" ? (
                            <EmptyState
                              size="sm"
                              className="tw-w-full"
                              title="Sorry! No Attribute found matching your search query"
                            />
                          ) : (
                            <Typography variant="body-primary" className="tw-text-ink-secondary">
                              No Attributes found
                            </Typography>
                          )}
                        </>
                      )}
                    </div>
                  </div>
                )}
              </>
            ) : (
              <div className="tw-pt-3">
                {associatedAttributes && associatedAttributes.length > 0 ? (
                  <div className="tw-flex tw-flex-wrap tw-gap-2">
                    {associatedAttributes.map((item, index) => (
                      <Tag key={index} label={item.name} variant="meta" />
                    ))}
                  </div>
                ) : (
                  <EmptyState size="sm" title="Associate Attributes Not Found" />
                )}
              </div>
            )}
          </>
        )}
      </div>
    </Accordion>
  );
};
export default AssociatedAttributes;
